import React from "react";
import "../../OptionBlocks/Logos/Logos.css";

const DeleteFontModal = ({
  setIsDeleteModalOpen,
  fontToDelete,
  handleDeleteFont
}) => {
  const handleNo = () => {
    setIsDeleteModalOpen(false);
  };

  const handleConfirm = () => {
    handleDeleteFont(fontToDelete);
  };

  return (
    <div className="logoEdit-container">
      <div className="logoEdit-overlay" onClick={handleNo} />
      <div className="logoEdit-content p-4">
        <h2 className="manrope-800 text-[1.2rem] text-white mt-2">
          Are you sure want to delete the font?
        </h2>
        <p className="w-[25rem] manrope-400 mt-[1rem] text-[0.9rem] text-white">
          If you delete <b>{fontToDelete?.fontFamily}</b>, it won't be reverted.
        </p>
        <div className="flex p-2 gap-4 justify-end mt-4 text-gray-900">
          <button className="updateLogoEditNoBtn" onClick={handleNo}>
            Cancel
          </button>
          <button
            className="updateLogoEdit"
            onClick={handleConfirm}
          >
            Yes, delete it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteFontModal;
